import { Box, Grid, Typography, useTheme } from "@mui/material";

import PhotoCarousel from "./PhotoCarousel";

export default function Details() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        px: 10,
        py: 4,
        bgcolor: theme.palette.primary.main,
        textAlign: "center",
      }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <PhotoCarousel
            images={[
              "https://picsum.photos/800/400?random=1",
              "https://picsum.photos/800/400?random=2",
              "https://picsum.photos/800/400?random=3",
              "https://picsum.photos/800/400?random=4",
              "https://picsum.photos/800/400?random=5",
              "https://picsum.photos/800/400?random=6",
              "https://picsum.photos/800/400?random=7",
              "https://picsum.photos/800/400?random=8",
            ]}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The Adventure
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            Get ready for epic adventures in this playhouse! The mighty
            FortKnight is fully equipped with a rock wall, ladder, two stories,
            and an armory, making it a spectacular spot for your next quest! Its
            durability is Scout tested and Scout approved.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The craft
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            We tapped into our childhood imaginations to create the playhouse of
            every kid’s dreams! Our one-of-a-kind, timeless fort is perfect to
            play in now, and will keep its value to resell later. Room for
            plenty of friends at 10’10’x14 and built out of pressure-treated
            wood with galvanized screws—this fort will hold up to years of play.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.custom.white,
            }}
          >
            The source
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white }}
          >
            adVenture Playhouses builds support San Diego local Venture Crew
            324, part of Scouting America, the hands and minds behind each
            playhouse edition. 100% of the proceeds go to our crew members,
            enabling us to support and fund our own adventures.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
